import { token } from '../constants/index'
import Cookies from 'js-cookie'

export function authToken() {
	return Cookies.get(token)
}
